import { IconMenu2, IconX } from "@tabler/icons-react";
import { useRouter } from "next/router";

import { useFeatureFlags } from "~/contexts/featureFlagProvider";
import { featureFlagAiEnabled } from "~/shared/constants/feature-flag.constants";
import { ActionIcon, ApplicationHeader, Flex, MobileOnly } from "~/ui";

import { ShelfCycleLogo } from "../_design-system/ShelfCycleLogo";
import { ActionCenterButton } from "../action-center/ActionCenterButton";
import { ChatButton } from "../chat-button/ChatButton";
import { AIChat } from "../domain/ai/AIChat";
import { InfoButton } from "../info-button/InfoButton";
import { UniversalSearch } from "../UniversalSearch";

import { isAssistantPageRoute } from "./assistant-route";
import styles from "./Header.module.css";

type HeaderProps = {
  isDesktop: boolean;
  navbarOpened: boolean;
  setNavbarOpened: (navbarOpened: boolean) => void;
};

export const Header = (props: HeaderProps): JSX.Element => {
  const router = useRouter();
  const { getFeatureFlag } = useFeatureFlags();

  const isAiEnabled = getFeatureFlag(featureFlagAiEnabled);
  const isAssistantRoute = isAssistantPageRoute(router.pathname);

  return (
    <ApplicationHeader>
      <Flex direction="row" gap="md" justify="center" align="center" h="100%">
        <MobileOnly>
          <ActionIcon variant="transparent">
            {!props.navbarOpened && <IconMenu2 onClick={() => props.setNavbarOpened(true)} />}
            {props.navbarOpened && <IconX onClick={() => props.setNavbarOpened(false)} />}
          </ActionIcon>
        </MobileOnly>
        <Flex>
          <ShelfCycleLogo />
        </Flex>
        <div style={{ flex: 1 }}>
          <Flex align="center" direction="row" gap="sm" maw={props.isDesktop ? "600px" : "100%"}>
            <UniversalSearch />
            {isAiEnabled && !isAssistantRoute && <AIChat />}
          </Flex>
        </div>
        <Flex align="center" gap={2} className={styles.actions}>
          <ActionCenterButton />
          <ChatButton />
          <InfoButton />
        </Flex>
      </Flex>
    </ApplicationHeader>
  );
};
